export default __webpack_public_path__ + "static/media/ic-schedule-text.d5d618d6.svg";